import COLORS, {getHfColors, getRFCColors} from './colors';

export const EXPERIMENT_MODEL_KEYS = new Set([
  'hydroforecast-seasonal-unassimilated',
  'hydroforecast-seasonal-untuned',
]);

export const MODEL_DISPLAY_NAMES: Record<string, string> = {
  hydroforecast: 'HydroForecast',
  'hydroforecast-seasonal': 'HydroForecast Seasonal',
  'hydroforecast-seasonal-unassimilated': 'HydroForecast Seasonal (No Assimilation)',
  'hydroforecast-seasonal-untuned': 'HydroForecast Seasonal (Untuned)',
  nwrfc: 'NWRFC',
  cbrfc: 'CBRFC',
  cnrfc: 'CNRFC',
  'compound-rfc': 'Compound RFC',
  persistence: 'Persistence',
  lta: 'Long-Term Average',
};

export const MODEL_COLORS: Record<string, string> = {
  hydroforecast: getHfColors(1)[0],
  'hydroforecast-seasonal-unassimilated': getHfColors(3)[0],
  'hydroforecast-seasonal-untuned': getHfColors(3)[1],
  nwrfc: getRFCColors(1)[0],
  cbrfc: getRFCColors(3)[1],
  cnrfc: getRFCColors(4)[2],
  'compound-rfc': getRFCColors(2)[1],
  persistence: '#9ca3af', // gray-400
  lta: '#a78bfa', // violet-400
  default: COLORS.OBS,
};

export function getModelColor(model: string): string {
  return MODEL_COLORS[model.toLowerCase()] || MODEL_COLORS.default;
}

export function getModelDisplayName(model: string, product?: 'short-term' | 'seasonal'): string {
  const key = model.toLowerCase();
  if (key === 'hydroforecast' && product === 'seasonal') return 'HydroForecast Seasonal';
  return MODEL_DISPLAY_NAMES[key] || model;
}
